import * as z from 'zod';
import { ComplaintSchema, MoodSchema, type CallExtraction } from './extraction';
import { FLAG_TYPES } from './flags';
import type { MentionTriage } from './triage';

/**
 * What the alert rules consume for one day. Stored as history, so it is plain JSON
 * and validated on read.
 */
export const DayFactsSchema = z.object({
  mood: MoodSchema.nullable().default(null),
  medsTaken: z.boolean().nullable().default(null),
  complaints: z.array(ComplaintSchema).default([]),
  redFlags: z.array(z.enum(FLAG_TYPES)).default([]),
  attentionFlags: z.array(z.enum(FLAG_TYPES)).default([]),
});
export type DayFacts = z.infer<typeof DayFactsSchema>;

export function toDayFacts(extraction: CallExtraction, triage: MentionTriage): DayFacts {
  return {
    mood: extraction.mood,
    medsTaken: extraction.meds_taken,
    complaints: extraction.complaints,
    redFlags: [...triage.redFlags],
    attentionFlags: [...triage.attentionFlags],
  };
}
